/*
 * Copyright (c) 2026 CTO's Club LLC. All rights reserved.
 * Author: Alex Baretta (alex@baretta.com).
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    createBrowserSpaBundleRevalidationEnvironment,
    createSpaBundleRevalidationState,
    revalidateSpaBundleForNavigation,
    type SpaBundleRevalidationResult,
    type SpaBundleRevalidationState,
} from '@/lib/spaBundleRevalidation';

const browserRevalidationState: SpaBundleRevalidationState =
    createSpaBundleRevalidationState();

export type SpaBundleRevalidatorProps = {
    readonly revalidate?: () => Promise<SpaBundleRevalidationResult>;
};

export function SpaBundleRevalidator({
    revalidate = revalidateCurrentBrowserBundle,
}: SpaBundleRevalidatorProps) {
    const location = useLocation();

    useEffect(() => {
        void revalidate().catch(() => undefined);
    }, [location.hash, location.key, location.pathname, location.search, revalidate]);

    return null;
}

function revalidateCurrentBrowserBundle(): Promise<SpaBundleRevalidationResult> {
    return revalidateSpaBundleForNavigation(
        createBrowserSpaBundleRevalidationEnvironment(),
        browserRevalidationState
    );
}
